/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */
import moment from 'moment';
const baseURL = process.env.VUE_APP_BASE_API;

const insertStr = (soure, start, newStr) => {
    return soure.slice(0, start) + newStr + soure.slice(start);
};
// 日期格式化
export function parseTime (time, pattern) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            if (time.length == 8) {
                time = insertStr(time, 4, '/');
                time = insertStr(time, 7, '/');
            } else {
                time = parseInt(time);
            }
        } else if (typeof time === 'string') {
            // time = time.replace(new RegExp(/-/gm), '/');
            time = Date.parse(new Date(time));
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value]; }
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}
// 编号方法
export function indexMethod (index, pageNum, pageSize) {
    return (
        index + 1 + (pageNum - 1) * pageSize
    );
}
// 表单重置
export function resetForm (refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange (params, dateRange, propName) {
    var search = params;
    search.params = {};
    if (dateRange && dateRange.length > 0) {
        if (typeof (propName) === 'undefined') {
            search.params['beginTime'] = dateRange[0];
            search.params['endTime'] = dateRange[1];
        } else {
            search.params['begin' + propName] = dateRange[0];
            search.params['end' + propName] = dateRange[1];
        }
    }
    return search;
}

// 回显数据字典
export function selectDictLabel (datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].dictValue === ('' + value)) {
            actions.push(datas[key].dictLabel);
            return true;
        }
    });
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels (datas, value, separator) {
    const actions = [];
    let temp;
    if (!value) {
        return '';
    }
    const currentSeparator = undefined === separator ? ',' : separator;
    if (Array.isArray(value)) {
        temp = [...value];
    } else {
        temp = value.split(currentSeparator);
    }
    Object.keys(temp).some((val) => {
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue == ('' + temp[val])) {
                actions.push(datas[key].dictLabel + currentSeparator);
            }
        });
    });
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 通用下载方法
export function download (fileName) {
    window.location.href = baseURL + '/common/download?fileName=' + encodeURI(fileName) + '&delete=' + true;
}

// 字符串格式化(%s )
export function sprintf (str) {
    var args = arguments, flag = true, i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty (str) {
    if (!str || str == 'undefined' || str == 'null') {
        return '';
    }
    return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree (data, id, parentId, children, rootId) {
    id = id || 'id';
    parentId = parentId || 'parentId';
    children = children || 'children';
    rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId]; })) || 0;
    // 对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data));
    // 循环所有项
    const treeData = cloneData.filter(father => {
        const branchArr = cloneData.filter(child => {
            // 返回每一项的子级数组
            return father[id] == child[parentId];
        });
        branchArr.length > 0 ? father.children = branchArr : '';
        // 返回第一层
        return father[parentId] == rootId;
    });
    return treeData != '' ? treeData : data;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams (params) {
    let result = '';
    Object.keys(params).forEach((key) => {
        if (!Object.is(params[key], undefined) && !Object.is(params[key], null) && !Object.is(JSON.stringify(params[key]), '{}')) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
        }
    });
    return result;
}

/**
 * 去除值为空字串，undefined，null对象的key
 * @param {any} Vue Vue库
 * @return {object}
 */
export function removeFreeObj (obj) {
    var newObj = {};
    if (typeof obj === 'string') {
        obj = JSON.parse(obj);
    }
    if (obj instanceof Array) {
        newObj = [];
    }
    if (obj instanceof Object) {
        for (var attr in obj) {
            // 属性值不为'',null,undefined才加入新对象里面(去掉'',null,undefined)
            if (obj.hasOwnProperty(attr) && obj[attr] !== '' && obj[attr] !== null && obj[attr] !== undefined) {
                if (obj[attr] instanceof Object) {
                    // 空数组或空对象不加入新对象(去掉[],{})
                    if (JSON.stringify(obj[attr]) === '{}' || JSON.stringify(obj[attr]) === '[]') {
                        continue;
                    }
                    // 属性值为对象,则递归执行去除方法
                    newObj[attr] = removeFreeObj(obj[attr]);
                } else if (
                    typeof obj[attr] === 'string' &&
                    ((obj[attr].indexOf('{') > -1 && obj[attr].indexOf('}') > -1) ||
                    (obj[attr].indexOf('[') > -1 && obj[attr].indexOf(']') > -1))
                ) {
                    // 属性值为JSON时
                    try {
                        var attrObj = JSON.parse(obj[attr]);
                        if (attrObj instanceof Object) {
                            newObj[attr] = removeFreeObj(attrObj);
                        }
                    } catch (e) {
                        newObj[attr] = obj[attr];
                    }
                } else {
                    newObj[attr] = obj[attr];
                }
            }
        }
    }
    return newObj;
}
export function getTime () {
    let dateTime = '';
    const yy = new Date().getFullYear();
    const mm = new Date().getMonth() + 1;
    const dd = new Date().getDate();
    // const hh = new Date().getHours();
    // const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
    //   : new Date().getMinutes();
    // const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
    //   : new Date().getSeconds();
    dateTime = yy + '-' + mm + '-' + dd;
    console.log(dateTime);
    return dateTime;
}
export function getMonth () {
    let arr = [
        {
            value: null,
            label: '全年'
        },
        {
            value: '01',
            label: '一月'
        },
        {
            value: '02',
            label: '二月'
        },
        {
            value: '03',
            label: '三月'
        },
        {
            value: '04',
            label: '四月'
        },
        {
            value: '05',
            label: '五月'
        },
        {
            value: '06',
            label: '六月'
        },
        {
            value: '07',
            label: '七月'
        },
        {
            value: '08',
            label: '八月'
        },
        {
            value: '09',
            label: '九月'
        },
        {
            value: '10',
            label: '十月'
        },
        {
            value: '11',
            label: '十一月'
        },
        {
            value: '12',
            label: '十二月'
        }
    ];
    return arr;
}
export function drawCircle (id, arr, options, colors = ['#2D55FF', '#FF7445', '#7FAAFE', '#43D9B1', '#8A6CFF']) {
    const {radius, lng, title, titleColor, horizon} = options;
    let dom = document.getElementById(id);
    dom.innerHTML = '';
    let c = document.createElement('canvas');
    c.height = dom.clientHeight;
    c.width = dom.clientWidth;
    let x = dom.clientWidth / 2;
    let y = dom.clientHeight / 2;
    dom.appendChild(c);
    let ctx = c.getContext('2d');
    // 求总和
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        sum += item.value;
    }
    // 绘制标题
    ctx.beginPath();
    ctx.fillStyle = titleColor;
    // 文字居中
    ctx.textAlign = 'center';
    // 相对原点垂直居中
    ctx.textBaseline = 'middle';
    // 文字样式：加粗 16像素 字体Arial
    ctx.font = 'normal 18px 微软雅黑';
    ctx.fillText(title, x, y);
    // 累计角度
    let sumAngle = 0;
    // 设置开始的位置
    let start = 1.5 * Math.PI;
    function drawLine (ctx, angle, color, item, rate) {
        let label = item.name + '：' + rate + '%';
        // 累计角度 - 当前的一半角度
        let bjAngle = sumAngle - angle;
        ctx.beginPath();
        ctx.globalCompositeOperation = 'destination-over';
        let chgAngle = 0.017453293 * bjAngle;
        // 设置起点状态
        let tmp1 = {
            x: x - radius * Math.sin(chgAngle),
            y: y - radius * Math.cos(chgAngle)
        };
        // 设置末端状态
        let tmp2 = {
            x: x - lng * Math.sin(chgAngle),
            y: y - lng * Math.cos(chgAngle)
        };
        ctx.moveTo(tmp1.x, tmp1.y);
        ctx.lineTo(tmp2.x, tmp2.y);
        // 设置线宽状态
        ctx.lineWidth = 1;

        let tmp3 = {};
        let tmp4 = {};
        // 向左绘制横线
        if (bjAngle < 180) {
            tmp3.x = tmp2.x - horizon;
            tmp3.y = tmp2.y;
            tmp4.x = tmp3.x - 6 * label.length;
            tmp4.y = tmp3.y;
        } else {
            tmp3.x = tmp2.x + horizon;
            tmp3.y = tmp2.y;
            tmp4.x = tmp3.x + 6 * label.length;
            tmp4.y = tmp3.y;
        }
        ctx.lineTo(tmp3.x, tmp3.y);
        // 进行绘制
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle = color;
        ctx.arc(tmp3.x, tmp3.y, 2, 0, 2 * Math.PI, true);
        ctx.fill();

        // 绘制标题
        ctx.beginPath();
        ctx.fillStyle = '#fff';
        // 相对原点垂直居中
        ctx.textBaseline = 'middle';
        // 文字样式：加粗 16像素 字体Arial
        ctx.font = 'normal 12px 微软雅黑';
        ctx.fillText(label, tmp4.x, tmp4.y);

        if (item.name1) {
            // 绘制标题
            ctx.beginPath();
            ctx.fillStyle = '#EC7677';
            // 相对原点垂直居中
            ctx.textBaseline = 'middle';
            // 文字样式：加粗 16像素 字体Arial
            ctx.font = 'normal 12px 微软雅黑';
            ctx.fillText('(' + item.name1 + ')', tmp4.x, tmp4.y + 12);
        }
    }

    // 动画
    function sleep (ms, callback) {
        setTimeout(callback, ms);
    }
    let lastItem = arr[arr.length - 1];
    for (let key = 0; key < arr.length; key++) {
        let item = arr[key];
        let rate = item.value / sum;
        let curColor = colors[key];
        sleep(80 * (key + 1), function () {
            ctx.beginPath();
            ctx.lineWidth = 20;
            ctx.strokeStyle = curColor;
            if (item.value == lastItem.value && item.name == lastItem.name) {
                // 先渲染一半
                let add = rate * Math.PI;
                ctx.arc(x, y, radius, start, start - add, true);
                ctx.lineCap = 'round';
                ctx.globalCompositeOperation = 'source-over';
                start -= add;
                ctx.stroke();
                ctx.beginPath();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.arc(x, y, radius, start, start - add, true);
                ctx.lineCap = 'butt';
                ctx.stroke();
            } else {
                let add = rate * 2 * Math.PI;
                ctx.arc(x, y, radius, start, start - add, true);
                ctx.lineCap = 'round';
                start -= add;
                ctx.stroke();
            }
            sumAngle += rate * 180 * 2;
            let angle = rate * 180;
            drawLine(ctx, angle, colors[key], item, Math.round(rate * 100));
            ctx.globalCompositeOperation = 'source-over';
        });
    }
}
export function isToday (date) {
    let isToday;
    if (new Date(date).getDate() === new Date().getDate()) {
        isToday = true;
    } else {
        isToday = false;
    }
    return isToday;
}

/**
 * @author: zhaoxf
 * @description: 格式化时间
 * @param {*} date
 * 今天是2023-02-13
 * 2023-02-13 09:44:34 -> 今天 09:44:34
 * 2023-02-12 09:44:34 -> 昨天 09:44:34
 * 2023-02-11 09:44:34 -> 2023-02-11 09:44:34
 */
export function parseDateTime (date) {
    if (!date) return ''; // date为空时，需要return空
    let inputTime = moment(date);
    if(!inputTime.isValid()) {
        try {
            inputTime = moment(Number(date));
        } catch (error) {
            return '-'
        }
        if(!inputTime.isValid()) {
            return '-'
        }
    }
    const now = moment();
    if (inputTime.isSame(now, 'day')) {
        return `今天 ${inputTime.format('HH:mm')}`;
    } else if (inputTime.isSame(now.subtract(1, 'days'), 'day')) {
        return `昨天 ${inputTime.format('HH:mm')}`;
    } else {
        return inputTime.format('YYYY-MM-DD HH:mm');
    }
}



// WEBPACK FOOTER //
// ./src/utils/YKScope.js